// extracted by mini-css-extract-plugin
export var contained = "SplashEmbed-module--contained--03ffa";
export var splashembed = "SplashEmbed-module--splashembed--4157b";